import { FaStar, FaUsers, FaTicket } from 'react-icons/fa6';
import { images } from ".";

const pricing = [
    {
        id: 1,
        icon: <FaTicket />, // Ticket icon
        image:images.flagIndonesia,
        title: 'Indonesia',
        price: 0,
        features: [
            'Robopark Indonbesia',
            'Pluit Village Mall, Lantai 2, Pluit, Kec. Penjaringan, Jkt Utara, Daerah Khusus Ibukota Jakarta 14450',
            'Tel: +62818663668 <yohanes>',
            'Website: Roboparkindonesia.id',
        ],
    },
    {
        id: 2,
        icon: <FaTicket />, // Ticket icon
        image:images.flagMalaysia,
        title: 'Malaysia',
        price: 0,
        features: [
            'SYSCORE ACADEMY & INNOVATION',
            'Tel: +6017-4029034 (MR. Dass)',
            'Web: www.syscore.com.my',
            'Email: Syscoresdnbhd@gmail.com',
            // '------------------------------',
            // 'Penang IRobotic Association',
            // 'Ts. Zamzuri Bin Hassan BCN, PKT',
            // 'Tel:+6019-5589052',
            // 'Email: zamzuri_jmti@yahoo.com'
        ],
    },
    {
        id: 3,
        icon: <FaStar />, // Star icon for VIP
        image:images.flagPhilippines,
        title: 'Philippines',
        price: 0,
        features: [
            'Data Science and Technology Corporation',
            'Ms. Josephine Legaspi',
            'Tel: +639603190834',
            'Email: philippineroboticsteam@gmail.com',
        ],
    },
    {
        id: 4,
        icon: <FaUsers />, // Users icon for group
        image:images.flagSingapore,
        title: 'Singapore',
        price: 0,
        features: [
            'Genexis Technologies',
            '47 Lorong Ong Lye Singapore 536419',
            'Tel: +65-98173531',
            'Email : cjsng@singnet.com.sg',
            '------------------------------',
            'Titan Tech Academy',
            'Suntec City',
            '3 Temasek Blvd, #02-738 / 739, Singapore 038983',
            'Tel: +65-98280578',
            'Web : https://titantechacademy.com/',        ],
    },
    {
        id: 5,
        icon: <FaUsers />, // Users icon for group
        image:images.flagThailand,
        title: 'THAILAND',
        price: 0,
        features: [
            'Innovative Experiment Co., Ltd.',
            'Mr. Chaiwat Limpornchitwilai',
            'Email: chaiwat@inex.co.th',
        ],
    },
    {
        id: 6,
        icon: <FaUsers />, // Users icon for group
        image: images.flagTaiwan,
        title: 'Taiwan',
        price: 0,
        features: [
            'V7 Idea Technology Ltd.',
            'Tel: +886-2-2655-1200',
            'Email: irene@v7idea.com.tw',
            'Email: louis@v7idea.com.tw',
            '------------------------------',
            'Lucky Coding Digital Education Co., Ltd.',
            'TEL: 03-3255877 / 0938285777',
            'Email: 777coding@gmail.com',
        ],
    },
];

export default pricing;